import React, { useState, useEffect } from 'react';

const baseURL = 'https://s3.us-east-2.amazonaws.com/ksusztak.genemap/daigoro/eQTL';

function DisplayGeneSNVData() {
    const [indexData, setIndexData] = useState([]);
    const [loadingIndex, setLoadingIndex] = useState(true);
    const [geneSearchTerm, setGeneSearchTerm] = useState('');
    const [snvSearchTerm, setSnvSearchTerm] = useState('');
    const [details, setDetails] = useState([]);
    const [geneSuggestions, setGeneSuggestions] = useState([]);

    useEffect(() => {
        fetch(`${baseURL}/index.json`)
            .then((response) => response.json())
            .then((data) => {
                setIndexData(Array.isArray(data) ? data : []);
                setLoadingIndex(false);
            })
            .catch(() => setLoadingIndex(false));
    }, []);

    const fetchData = (type, term) => {
        const path = type === 'gene' ? `genes/${term.toLowerCase()}.json` : `snvs/${term.toLowerCase()}.json`;
        fetch(`${baseURL}/${path}`)
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => setDetails(data || []))
            .catch(() => setDetails([]));
    };

    const handleGeneChange = (e) => {
        const term = e.target.value;
        setGeneSearchTerm(term);
        setSnvSearchTerm(''); // Clear SNV search term
        setDetails([]);
        if (term) {
            const matches = indexData.filter((gene) => gene.toLowerCase().startsWith(term.toLowerCase()));
            setGeneSuggestions(matches);

            // Automatically load data if there is an exact match
            if (matches.length === 1 && matches[0].toLowerCase() === term.toLowerCase()) {
                fetchData('gene', matches[0]);
                setGeneSuggestions([]);
            }
        } else {
            setGeneSuggestions([]);
        }
    };

    const handleGeneKeyPress = (e) => {
        if (e.key === 'Enter' && geneSearchTerm) {
            fetchData('gene', geneSearchTerm);
            setGeneSuggestions([]);
        }
    };

    const handleGeneSelect = (gene) => {
        setGeneSearchTerm(gene);
        setGeneSuggestions([]);
        fetchData('gene', gene);
    };

    const handleSNVChange = (e) => {
        const term = e.target.value;
        setSnvSearchTerm(term);
        setGeneSearchTerm(''); // Clear Gene search term
        setDetails([]);
        if (term.toLowerCase().startsWith('rs')) {
            fetchData('snv', term);
        }
    };

    if (loadingIndex) {
        return <div>Loading index data...</div>;
    }

    return (
        <div className="display-gene-snv-data">
            <h1>Gene and SNV Data Viewer</h1>
            <div>
                <label>Search for Gene: </label>
                <input
                    type="text"
                    value={geneSearchTerm}
                    onKeyPress={handleGeneKeyPress}
                    onChange={handleGeneChange}
                    placeholder="Enter Gene Symbol"
                />
                {geneSuggestions.length > 0 && (
                    <ul>
                        {geneSuggestions.map((gene) => (
                            <li key={gene} onClick={() => handleGeneSelect(gene)}>
                                {gene}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div>
                <label>Search for SNV: </label>
                <input
                    type="text"
                    value={snvSearchTerm}
                    onChange={handleSNVChange}
                    placeholder="Enter SNV ID (e.g., rs377763)"
                />
            </div>
            {details.length > 0 && (
                <div>
                    <h2>Details</h2>
                    <table border="1">
                        <thead>
                            <tr>
                                {Object.keys(details[0]).map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {details.map((detail, index) => (
                                <tr key={index}>
                                    {Object.values(detail).map((value, i) => (
                                        <td key={i}>{value !== null && typeof value === 'object' ? JSON.stringify(value) : value}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default DisplayGeneSNVData;

